/* Notes: docs/code-notes/assets/truce.js.md (repo only). Keep this file comment-free. */
(function () {
  'use strict';

  var stickyHdr = document.querySelector('.truce-header--sticky');
  if (stickyHdr) {
    var spacer = document.createElement('div');
    spacer.style.display = 'none';
    stickyHdr.parentNode.insertBefore(spacer, stickyHdr.nextSibling);
    var stuck = false, stickAt = 0;
    var onScroll = function () {
      if (!stuck) stickAt = stickyHdr.getBoundingClientRect().top + window.scrollY;
      if (!stuck && window.scrollY > stickAt) {
        stuck = true;
        spacer.style.height = stickyHdr.offsetHeight + 'px';
        spacer.style.display = 'block';
        stickyHdr.classList.add('is-stuck');
      } else if (stuck && window.scrollY <= stickAt) {
        stuck = false;
        spacer.style.display = 'none';
        stickyHdr.classList.remove('is-stuck');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.querySelectorAll('[data-menu-toggle]').forEach(function (toggle) {
    var header = toggle.closest('.truce-header');
    var drawer = header && header.querySelector('.truce-mobile-menu');
    if (!drawer) return;
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('[data-icon-open]').style.display = open ? 'none' : '';
      toggle.querySelector('[data-icon-close]').style.display = open ? '' : 'none';
    });
  });

  document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      if (!sub) return;
      var open = sub.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('.truce-header__nav').forEach(function (navRoot) {
    var items = navRoot.querySelectorAll(':scope > li');
    function closeAll(except) {
      items.forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var b = li.querySelector(':scope > button');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (li) {
      var btn = li.querySelector(':scope > button');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = li.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        closeAll(li);
      });
    });
    document.addEventListener('click', function (e) {
      if (!navRoot.contains(e.target)) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  });

  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    var items = acc.querySelectorAll('.truce-accordion__item');
    items.forEach(function (item) {
      var q = item.querySelector('.truce-accordion__q');
      if (!q) return;
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var b = i.querySelector('.truce-accordion__q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('.testimonial-carousel__track');
    var slides = root.querySelectorAll('.testimonial-slide');
    if (!track || slides.length < 2) return;
    var idx = 0;
    var interval = parseInt(root.getAttribute('data-autoplay') || '6000', 10);
    var timer = null;
    var dots = root.querySelectorAll('.testimonial-carousel__dot');

    function go(n) {
      idx = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + idx * 100 + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function play() { stop(); timer = setInterval(function () { go(idx + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); }

    var prev = root.querySelector('.testimonial-carousel__arrow--prev');
    var next = root.querySelector('.testimonial-carousel__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); play(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); play(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); play(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    go(0); play();
  });

  document.querySelectorAll('[data-modal-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var modal = document.getElementById(trigger.getAttribute('data-modal-open'));
      if (!modal) return;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.truce-modal__close');
      if (closeBtn) closeBtn.focus();
    });
  });
  document.querySelectorAll('.truce-modal').forEach(function (modal) {
    function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
    modal.querySelectorAll('[data-modal-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  });

  document.querySelectorAll('[data-video-play]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-inline-video]') || btn.parentElement;
      var video = wrap.querySelector('video');
      if (!video) return;
      btn.classList.add('is-hidden');
      video.controls = true;
      video.play();
    });
  });

  (function () {
    var warm = function (root) {
      root.querySelectorAll('img[data-feature-img][loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
    };
    if ('IntersectionObserver' in window) {
      var pre = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          warm(en.target); pre.unobserve(en.target);
        });
      }, { rootMargin: '600px 0px' });
      document.querySelectorAll('[data-value-tabs]').forEach(function (r) { pre.observe(r); });
    } else {
      document.querySelectorAll('[data-value-tabs]').forEach(warm);
    }
  })();

  document.querySelectorAll('[data-value-tabs]').forEach(function (root) {
    root.querySelectorAll('.module-value__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('.module-value__tab').forEach(function (t) {
          t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false');
        });
        root.querySelectorAll('.module-value__panel').forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
        var panel = document.getElementById(tab.getAttribute('data-tab-target'));
        if (panel) {
          panel.classList.add('is-active');
          var open = panel.querySelector('.truce-accordion__item.is-open');
          if (!open) {
            var q0 = panel.querySelector('.truce-accordion__item .truce-accordion__q');
            if (q0) { q0.click(); open = panel.querySelector('.truce-accordion__item.is-open'); }
          }
          if (open) {
            var imgName = open.getAttribute('data-feature-image');
            if (imgName) panel.querySelectorAll('[data-feature-img]').forEach(function (img) {
              img.classList.toggle('is-hidden', img.getAttribute('data-feature-img') !== imgName);
            });
          }
        }
      });
    });
    root.querySelectorAll('[data-feature-accordion]').forEach(function (acc) {
      acc.addEventListener('click', function () {
        var open = acc.querySelector('.truce-accordion__item.is-open');
        if (!open) return;
        var imgName = open.getAttribute('data-feature-image');
        var panel = acc.closest('.module-value__panel');
        if (!panel || !imgName) return;
        panel.querySelectorAll('[data-feature-img]').forEach(function (img) {
          img.classList.toggle('is-hidden', img.getAttribute('data-feature-img') !== imgName);
        });
      });
    });
  });

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-value-tabs]').forEach(function (root) {
      var timer = null;
      function cycle() {
        var panel = root.querySelector('.module-value__panel.is-active');
        if (!panel) return;
        var items = [].slice.call(panel.querySelectorAll('.truce-accordion__item'));
        if (items.length < 2) return;
        var idx = items.findIndex(function (it) { return it.classList.contains('is-open'); });
        var q = items[(idx + 1) % items.length].querySelector('.truce-accordion__q');
        if (q) q.click();
      }
      function restart() { clearInterval(timer); timer = setInterval(cycle, 15000); }
      root.addEventListener('click', function (e) { if (!e.isTrusted) return; restart(); });
      restart();
    });
  }

  var isHome = document.body.classList.contains('template-index');
  if (!isHome && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var units = [];
    var sections = [...document.querySelectorAll('main .shopify-section')];
    sections.forEach(function (sec, i) {
      if (i === 0) return;
      var blocks = sec.querySelectorAll('.module-row, .icon-grid__grid > .icon-box, .resource-card, .partner-card, .team-card, .faq-section__grid > *, .card-row > *, .stats-band__grid, .home-hero, .section__intro, .split-content__grid > *, .about-story__step, .about-story__media');
      if (blocks.length > 1) units.push.apply(units, blocks);
      else units.push(sec);
    });
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('reveal-pending');
          entry.target.classList.add('reveal-in');
          revealIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0 });
    var vh = window.innerHeight || document.documentElement.clientHeight;
    units.forEach(function (u) {
      var r = u.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) return;
      u.classList.add('reveal-pending');
      revealIO.observe(u);
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-loaded');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '80px' });
    document.querySelectorAll('.lazy-fade').forEach(function (img) { io.observe(img); });
  } else {
    document.querySelectorAll('.lazy-fade').forEach(function (img) { img.classList.add('is-loaded'); });
  }

  function scrollToTarget(target) {
    var startY = window.scrollY;
    target.scrollIntoView({ behavior: 'smooth' });
    setTimeout(function () {
      var rect = target.getBoundingClientRect();
      var offTarget = rect.top > 200 || rect.top < -200;
      if (Math.abs(window.scrollY - startY) < 4 && offTarget) {
        target.scrollIntoView({ behavior: 'instant' });
      }
    }, 450);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || !a.hash) return;
    if (a.origin !== location.origin || a.pathname !== location.pathname) return;
    var target = document.querySelector(a.hash);
    if (!target) return;
    e.preventDefault();
    if (a.hash !== location.hash) {
      try { history.replaceState({ truceY: window.scrollY }, '', location.href); } catch (err) {}
      history.pushState({ truceAnchor: a.hash }, '', a.hash);
    }
    scrollToTarget(target);
  });

  window.addEventListener('popstate', function (e) {
    var st = e.state;
    try {
      if (st && typeof st.truceY === 'number') {
        try { window.scrollTo({ top: st.truceY, behavior: 'instant' }); } catch (err) { window.scrollTo(0, st.truceY); }
      } else if (st && st.truceAnchor) {
        var t = document.querySelector(st.truceAnchor);
        if (t) scrollToTarget(t);
      }
    } catch (err2) {}
  });

  if (location.hash) {
    window.addEventListener('load', function () {
      var target = document.querySelector(location.hash);
      if (target) setTimeout(function () { scrollToTarget(target); }, 100);
    });
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  var host = location.hostname;
  document.querySelectorAll('a[href^="http"]').forEach(function (a) {
    if (a.hostname && a.hostname !== host && !a.target) {
      a.target = '_blank';
      a.rel = a.rel ? a.rel + ' noopener' : 'noopener';
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var STEPS = [
    { type: 'single', key: 'fleet_size', title: 'How many vehicles are in your fleet?', grid: true,
      sub: 'One tap. Then we build your exact number and send it to you.',
      opts: ['1 – 9', '10 – 24', '25 – 50', '51 – 100', '101 – 250', '251 – 500', '501 – 999', '1,000+'] },
    { type: 'price', key: 'next_step', title: 'Less than $30 per employee, per month.',
      line: 'AI dash cameras, GPS on the road <b>and on the job site</b>, driver ID, scores and coaching, distraction blocking, vehicle diagnostics.',
      anchor: '<b>The other platforms:</b> $40 – $60+ per vehicle, per month for just GPS and AI cameras.',
      tease: '$30 is the ceiling, not your number.',
      teaseSub: 'Bigger fleets pay less.' },
    { type: 'done', title: 'Your number is on the way.' }
  ];
  var OFFER_TAG = 'End-of-year offer 2026 (pricing quiz)';
  var OFFER = Date.now() < Date.UTC(2027, 0, 1, 6) ? {
    tag: OFFER_TAG,
    eyebrow: 'Year-end pricing &middot; lock it in by Dec&nbsp;31',
    title: '<b>$15</b> per vehicle, per month for your first 6&nbsp;months.',
    line: 'Then $25. Everything for your <b>{fs} vehicle</b> fleet: AI dash cams, GPS, driver scoring and coaching, device-distracted driving prevention. The other platforms charge $40 to $60+ per vehicle.',
    checks: ['Camera and vehicle connector included, no activation fee', 'Free 30-day demo, hardware included', 'Under contract elsewhere? We\u2019ll hold this price until it ends.'],
    button: 'Hold my $15 price',
    trust: 'Free. Nothing to sign. No calls unless you ask.',
    contract: ['2026', '2027', '2028 or later', 'Not under contract']
  } : null;
  if (OFFER && window.__truceCold) { OFFER.eyebrow = 'Your price'; STEPS[0].sub = 'One tap. See your price and hold it.'; }
  else if (OFFER) STEPS[0].sub = 'One tap. See your year-end price and hold it.';
  var PQ_FINE = false;
  try { PQ_FINE = !!(window.matchMedia && window.matchMedia('(pointer: fine)').matches); } catch (e) {}
  var PQ_FB_COLD = false;
  try { PQ_FB_COLD = !!window.__truceCold && (new URLSearchParams(location.search).get('utm_campaign') || '').toLowerCase().indexOf('fbt4-') === 0; } catch (e) {}
  var PQ_EMAIL_PH = PQ_FB_COLD ? 'Email' : 'Work email';
  var QUOTES = [
    { q: '“Before TRUCE 35% of the drivers were involved in a crash. The following year our average number of employee crashes fell to 10% which is below our industry benchmark.”', a: 'Nationwide Sales Fleet — Head of Health, Safety and Environment' },
    { q: '“TRUCE gave us peace of mind. It’s like having a safety coach in every vehicle—helping us lower risk, protect our employees, and build a stronger safety culture.”', a: 'Kannon Cravey, Technical Manager — Romex Pest Control' },
    { q: '"Changing from a discipline model to a reward culture made all the difference. Employees see we care about their safety, not just the company’s bottom line."', a: 'Scott Moberly, Co-Owner — Ventura Pest Control' }
  ];

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  var PQ_STASH = 'truce_pq';
  function stashSet(o) { try { sessionStorage.setItem(PQ_STASH, JSON.stringify(o)); } catch (e) {} }
  function stashGet() { try { return JSON.parse(sessionStorage.getItem(PQ_STASH) || 'null'); } catch (e) { return null; } }
  function stashClear() { try { sessionStorage.removeItem(PQ_STASH); } catch (e) {} }

  function pqInit(root) {
    var HANDLER = (root.getAttribute('data-handler') || '').trim();
    var isModal = root.hasAttribute('data-pq-modal');
    var inlineKey = root.getAttribute('data-pq-inline') || '';
    var isInline = !!inlineKey;
    var inlineOpened = false;
    var partialSentFor = '';
    var i = 0, answers = {}, qi = 0;
    var stepEl = root.querySelector('[data-pq-step]');
    var busy = false, busyBtn = null, busyLbl = '', busyTimer = null;
    var autoFocusing = false, emailFocusSent = false;
    function unbusy() {
      if (busyTimer) { clearTimeout(busyTimer); busyTimer = null; }
      if (!busy) return;
      busy = false; window.__trucePqPosting = 0;
      if (busyBtn) { busyBtn.removeAttribute('aria-disabled'); busyBtn.removeAttribute('aria-busy'); if (busyLbl) busyBtn.textContent = busyLbl; }
      busyBtn = null;
      validate();
    }

    function q(sel) { return root.querySelector(sel); }

    function renderQuote() {
      q('[data-pq-quote]').textContent = QUOTES[qi].q;
      q('[data-pq-attrib]').textContent = QUOTES[qi].a;
      q('[data-pq-dots]').innerHTML = QUOTES.map(function (_, j) {
        return '<span class="' + (j === qi ? 'on' : '') + '" data-dot="' + j + '"></span>';
      }).join('');
    }
    root.addEventListener('click', function (e) {
      var d = e.target.getAttribute && e.target.getAttribute('data-dot');
      if (d !== null && d !== undefined) { qi = +d; renderQuote(); }
    });
    renderQuote();
    setInterval(function () { qi = (qi + 1) % QUOTES.length; renderQuote(); }, 8000);

    function payload() {
      var name = (answers.name || '').trim(), sp = name.indexOf(' ');
      return {
        email: answers.email || '',
        first_name: sp > -1 ? name.slice(0, sp) : name,
        last_name: sp > -1 ? name.slice(sp + 1) : '',
        company: answers.company || '', phone: answers.phone || '',
        fleet_size: answers.fleet_size || '',
        interests: [
          answers.offer || '',
          (answers.interests || []).join(', '),
          answers.next_step ? 'next: ' + answers.next_step : '',
          answers.interest_path ? 'path: ' + answers.interest_path : ''
        ].filter(Boolean).join(' | '),
        industry: answers.industry || '',
        next_step: answers.next_step || '',
        interest_path: answers.interest_path || ''
      };
    }

    function render() {
      var s = STEPS[i];
      var PQ_PCT = [0, 90, 100];
      var _pct = PQ_PCT[Math.min(i, PQ_PCT.length - 1)];
      q('[data-pq-pct]').textContent = _pct + '%';
      q('[data-pq-fill]').style.width = _pct + '%';
      var _title = s.title, _sub = s.sub;
      var _next = 'Next';
      var h = '';
      if (s.type === 'single' || s.type === 'multi') {
        h += '<h2 class="pq__title">' + _title + '</h2>';
        if (_sub) h += '<p class="pq__hint" style="margin:2px 0 10px">' + _sub + '</p>';
        var shortOpts = s.opts && Math.max.apply(null, s.opts.map(function (o) { return o.length; })) <= 9;
        h += '<div class="pq__opts' + (s.grid ? ' pq__opts--grid' : '') + (s.grid && shortOpts ? ' pq__opts--sm' : '') + '">' + s.opts.map(function (o, j) {
          var sel = s.type === 'multi' ? (answers[s.key] || []).indexOf(o) > -1 : answers[s.key] === o;
          return '<button type="button" class="pq__opt' + (sel ? ' is-sel' : '') + '" data-pick="' + j + '">' + o + '</button>';
        }).join('') + '</div>';
        if (s.type === 'multi') h += '<p class="pq__hint">Select all that apply</p>';
      } else if (s.type === 'price') {
        var fs = answers.fleet_size || '';
        answers.offer = '';
        var fsOffer = !!OFFER && STEPS[0].opts.indexOf(fs) > -1;
        _next = 'Email me my exact quote';
        h += '<div class="pq__fs"><span class="pq__fs-chip">' + esc(fs) + ' vehicles ✓</span><button type="button" class="pq__fs-change" data-nav="-1">change</button></div>';
        if (fsOffer) {
          answers.offer = OFFER.tag;
          _next = OFFER.button;
          h += '<p class="pq__eyebrow">' + OFFER.eyebrow + '</p>';
          h += '<h2 class="pq__title pq__title--price">' + OFFER.title + '</h2>';
          h += '<p class="pq__line">' + OFFER.line.split('{fs}').join(esc(fs)) + '</p>';
          h += '<ul class="pq__checks">' + OFFER.checks.map(function (c) { return '<li>' + c + '</li>'; }).join('') + '</ul>';
        } else {
          h += '<h2 class="pq__title pq__title--price">' + _title + '</h2>';
          h += '<p class="pq__line">Everything included for your <b>' + esc(fs) + ' vehicle</b> fleet: ' + s.line + '</p>';
          h += '<div class="pq__anchor">' + s.anchor + '</div>';
          if (fs !== '10 – 24') {
            h += '<p class="pq__tease">' + s.tease + '</p>';
            h += '<p class="pq__tease-sub">' + s.teaseSub + '</p>';
          }
        }
        h += '<div class="pq__fields pq__fields--price">' +
          '<input type="email" data-f="email" placeholder="' + PQ_EMAIL_PH + '" value="' + esc(answers.email || '') + '" autocomplete="email" inputmode="email" autocapitalize="off">' +
          '<p class="pq__error pq__error--field" data-pq-emerr hidden role="alert"></p>' +
          '<input type="text" data-f="name" placeholder="First name" value="' + esc(answers.name || '') + '" autocomplete="given-name" autocapitalize="words">' +
          '</div>';
        h += '<p class="pq__error" data-pq-err hidden role="alert"></p>';
        if (fsOffer) h += '<p class="pq__hint pq__hint--trust">' + OFFER.trust.split('{fs}').join(esc(fs)) + '</p>';
        else h += '<p class="pq__hint pq__hint--trust">Your exact number for your fleet size, all six modules or only the ones you want, on one page within one business day. Every quote comes with the option of a free 30-day demo, hardware included. No calls unless you ask.</p>';
      } else if (s.type === 'done') {
        var st = stashGet() || {};
        var _doneEmail = st.email || '';
        var _doneBody = 'Within <strong>one business day</strong>, from a real person at TRUCE.';
        var _fd = false; try { _fd = sessionStorage.getItem('truce_fd') === '1'; } catch (e) {}
        if (_fd) {
          _title = 'Demo unit request received.';
          _doneBody = 'A TRUCE expert will call to schedule your shipment and set up your map, usually within <strong>one business day</strong>.';
          _doneEmail = '';
          try { sessionStorage.removeItem('truce_fd'); } catch (e) {}
        } else if (_doneEmail) {
          if (st.offer && OFFER) {
            _title = 'Your $15 price is held.';
            _doneBody = 'We’ll email ' + esc(_doneEmail) + ' within <strong>one business day</strong>, from a real person at TRUCE.';
          } else {
            _title = 'Your number is on the way to ' + esc(_doneEmail) + '.';
          }
        }
        h = '<div class="pq__done"><h2 class="pq__title">' + _title + '</h2>' +
          '<p>' + _doneBody + '</p>';
        if (_doneEmail && HANDLER && !st.phone_sent) {
          h += '<div class="pq__text" data-pq-text>' +
            '<h3>Rather we text it?</h3>' +
            '<div class="pq__text-row"><input type="tel" data-f="phone2" placeholder="(555) 555-0123" autocomplete="tel" inputmode="tel"><button type="button" class="pq__btn pq__btn--next pq__btn--navy" data-text="1" disabled>Text me</button></div>' +
            '<p class="pq__hint">One text with your price, from a real person. No marketing texts.</p>' +
            '</div>';
        }
        if (_doneEmail && HANDLER && st.offer && OFFER && !st.contract_sent) {
          h += '<div class="pq__text" data-pq-contract>' +
            '<h3>When does your current contract end?</h3>' +
            '<div class="pq__opts pq__opts--grid pq__opts--sm" role="group" aria-label="When does your current contract end?">' + OFFER.contract.map(function (c) { return '<button type="button" class="pq__opt" data-contract="' + esc(c) + '">' + esc(c) + '</button>'; }).join('') + '</div>' +
            '<p class="pq__hint">Optional. It tells us when to start your fleet.</p>' +
            '</div>';
        }
        h += '<p>In the meantime: <a href="/pages/resources">customer stories and research</a>, or see <a href="/pages/road">how the platform works</a>.</p>';
        if (!HANDLER && answers.email) {
          h += '<div class="pq__payload"><div class="pq__payload-title">DEMO MODE (no Pardot handler configured) — payload that would be sent:</div>' + esc(JSON.stringify(payload(), null, 2)) + '</div>';
        }
        h += '</div>';
      }
      if (s.type !== 'done') {
        h += '<div class="pq__btns">' + (i > 0 && s.type !== 'price' ? '<button type="button" class="pq__btn pq__btn--back" data-nav="-1">Back</button>' : '') +
          '<button type="button" class="pq__btn pq__btn--next" data-nav="1" disabled>' + _next + '</button></div>';
      }
      stepEl.classList.toggle('pq__step--dense', s.type === 'price');
      stepEl.innerHTML = h;
      validate();
      var first = stepEl.querySelector('input');
      if (first && !isInline && (s.type !== 'price' || PQ_FINE)) { autoFocusing = true; try { first.focus(); } catch (e) {} autoFocusing = false; }
      if (s.type === 'price') pqTrack('pq_price_view', { fleet_size: answers.fleet_size || '', answer: answers.fleet_size || '' });
      if (isInline && i > 0) {
        var top = root.getBoundingClientRect().top;
        if (top < 70 || top > window.innerHeight - 200) {
          try { window.scrollTo({ top: window.scrollY + top - 84, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, window.scrollY + top - 84); }
        }
      }
    }

    function validate() {
      var s = STEPS[i], n = stepEl.querySelector('[data-nav="1"]');
      if (s.type === 'done') {
        var tb = stepEl.querySelector('[data-text]');
        if (tb) { var pv = ((stepEl.querySelector('[data-f="phone2"]') || {}).value || '').replace(/\D/g, ''); tb.disabled = pv.length < 10; }
        return;
      }
      if (!n) return;
      var ok = false;
      if (s.type === 'single') ok = !!answers[s.key];
      else if (s.type === 'multi') ok = (answers[s.key] || []).length > 0;
      else if (s.type === 'price') {
        var nm = (stepEl.querySelector('[data-f="name"]') || {}).value || '';
        var v = (stepEl.querySelector('[data-f="email"]') || {}).value || '';
        ok = nm.trim().length > 0 && /.+@.+\..+/.test(v);
        answers.name = nm.trim(); if (/.+@.+\..+/.test(v)) answers.email = v.trim();
        answers.next_step = 'Get my exact pricing';
        var er = stepEl.querySelector('[data-pq-err]'); if (er && ok) er.hidden = true;
        var emr = stepEl.querySelector('[data-pq-emerr]');
        if (emr && !emr.hidden && emr.getAttribute('data-for') !== v.trim()) {
          emr.hidden = true;
          var emi = stepEl.querySelector('[data-f="email"]'); if (emi) emi.removeAttribute('aria-invalid');
        }
        n.disabled = false; return;
      }
      n.disabled = !ok;
    }

    var personalTracked = false;
    function showEmailErr(msg, via) {
      var emIn = stepEl.querySelector('[data-f="email"]'), emEr = stepEl.querySelector('[data-pq-emerr]');
      if (!emIn || !emEr) return false;
      emEr.textContent = msg; emEr.hidden = false; emEr.setAttribute('data-for', (emIn.value || '').trim());
      emIn.setAttribute('aria-invalid', 'true');
      var gen = stepEl.querySelector('[data-pq-err]'); if (gen) gen.hidden = true;
      if (!personalTracked) { personalTracked = true; pqTrack('email_personal_blocked', { form: 'pricing_quiz', via: via }); }
      return true;
    }

    function sendPhone(phone) {
      var st = stashGet() || {};
      if (!HANDLER || !st.email) return false;
      var body = new URLSearchParams();
      body.append('email', st.email); body.append('phone', phone);
      if (st.first_name) body.append('first_name', st.first_name);
      if (st.fleet_size) body.append('fleet_size', st.fleet_size);
      body.append('interests', (st.offer ? st.offer + ' | ' : '') + 'next: Get my exact pricing | text_me: yes' + (st.contract ? ' | contract_end: ' + st.contract : ''));
      try { var u2 = window.truceUtm ? window.truceUtm() : {}; Object.keys(u2).forEach(function (k) { body.append(k, u2[k]); }); } catch (e) {}
      try {
        fetch(HANDLER, { method: 'POST', mode: 'no-cors', body: body,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
      } catch (err) {}
      st.phone_sent = 1; stashSet(st);
      return true;
    }

    function sendContract(val) {
      var st = stashGet() || {};
      if (!HANDLER || !st.email) return false;
      var body = new URLSearchParams();
      body.append('email', st.email);
      if (st.first_name) body.append('first_name', st.first_name);
      if (st.fleet_size) body.append('fleet_size', st.fleet_size);
      body.append('contract_end', val);
      body.append('interests', (st.offer ? st.offer + ' | ' : '') + 'next: Get my exact pricing' + (st.phone_sent ? ' | text_me: yes' : '') + ' | contract_end: ' + val);
      try { var u2 = window.truceUtm ? window.truceUtm() : {}; Object.keys(u2).forEach(function (k) { body.append(k, u2[k]); }); } catch (e) {}
      try {
        fetch(HANDLER, { method: 'POST', mode: 'no-cors', body: body,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
      } catch (err) {}
      st.contract_sent = 1; st.contract = val; stashSet(st);
      return true;
    }

    function submit() {
      if (!HANDLER) { unbusy(); i = STEPS.length - 1; render(); return; }
      var f = root.querySelector('[data-pq-form]'), p = payload();
      if ((f.querySelector('[name="pq_website"]') || {}).value) { unbusy(); return; }
      f.setAttribute('action', HANDLER);
      Object.keys(p).forEach(function (k) { var inp = f.querySelector('[name="' + k + '"]'); if (inp) inp.value = p[k]; });
      try {
        var u = window.truceUtm ? window.truceUtm() : {};
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
          var ui = f.querySelector('[name="' + k + '"]'); if (!ui) return;
          if (u[k]) { ui.value = u[k]; ui.disabled = false; } else { ui.disabled = true; }
        });
        ['gclid', 'meta_click_id', 'linkedin_click_id', 'landing_page'].forEach(function (k) {
          if (!u[k]) return;
          var ui = f.querySelector('[name="' + k + '"]');
          if (!ui) { ui = document.createElement('input'); ui.type = 'hidden'; ui.name = k; f.appendChild(ui); }
          ui.value = u[k]; ui.disabled = false;
        });
      } catch (e) {}
      f.removeAttribute('hidden');
      f.submit();
    }

    function pqTrack(name, extra, gx) {
      var params = extra || {};
      params.quiz_step = (STEPS[i] && STEPS[i].key) || STEPS[i].type || i;
      params.is_modal = isModal ? 'yes' : 'no';
      if (isInline) params.inline = inlineKey;
      if (window.__truceVariant) params.lp_variant = window.__truceVariant;
      if (answers.next_step) params.next_step = answers.next_step;
      if (window.truceTrack) window.truceTrack(name, params, gx);
    }
    if (isInline) {
      var seen = false;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting && !seen) { seen = true; io.disconnect(); if (!window.__truceInlineViewed) { window.__truceInlineViewed = 1; pqTrack('pq_view', { page: location.pathname }); } } });
        }, { threshold: 0.3 });
        io.observe(root);
      }
    } else if (!isModal) {
      var _rq = new URLSearchParams(location.search);
      if (_rq.get('submitted') !== '1' && _rq.get('error') !== '1' && _rq.get('errors') !== 'true') pqTrack('pq_view');
    }

    stepEl.addEventListener('click', function (e) {
      if (busy) return;
      var pick = e.target.getAttribute && e.target.getAttribute('data-pick');
      if (pick !== null && pick !== undefined) {
        if (isInline && !inlineOpened) {
          inlineOpened = true;
          pqTrack('pq_open', { page: location.pathname, cta: 'inline_' + inlineKey });
          pqTrack('pq_inline', { page: location.pathname, section: inlineKey });
        }
        var s = STEPS[i], o = s.opts[+pick];
        if (s.type === 'multi') {
          var a = answers[s.key] || [], ix = a.indexOf(o);
          if (ix > -1) a.splice(ix, 1); else a.push(o);
          answers[s.key] = a;
        } else {
          answers[s.key] = o;
          render();
          var stepAt = i;
          setTimeout(function () {
            if (i !== stepAt) return;
            var n = stepEl.querySelector('[data-nav="1"]');
            if (n && !n.disabled) n.click();
          }, 250);
          return;
        }
        render(); return;
      }
      var ce = e.target.getAttribute && e.target.getAttribute('data-contract');
      if (ce) {
        if (sendContract(ce)) {
          pqTrack('pq_contract_end', { answer: ce });
          var cbx = stepEl.querySelector('[data-pq-contract]');
          if (cbx) {
            cbx.innerHTML = '<h3 tabindex="-1">' + (ce === 'Not under contract' ? 'Thanks. Noted.' : 'Thanks. Noted: your contract ends in ' + esc(ce) + '.') + '</h3>';
            try { cbx.querySelector('h3').focus({ preventScroll: true }); } catch (e2) {}
          }
        }
        return;
      }
      if (e.target.getAttribute && e.target.getAttribute('data-text')) {
        var ph = ((stepEl.querySelector('[data-f="phone2"]') || {}).value || '').trim();
        if (ph.replace(/\D/g, '').length < 10) return;
        if (sendPhone(ph)) {
          pqTrack('pq_phone_captured');
          var box = stepEl.querySelector('[data-pq-text]');
          if (box) box.innerHTML = '<h3>Got it. We’ll text it to ' + esc(ph) + '.</h3>';
        }
        return;
      }
      var nav = e.target.getAttribute && e.target.getAttribute('data-nav');
      if (nav) {
        if (nav === '1' && STEPS[i].type === 'price') {
          if (busy || window.__trucePqPosting) return;
          var _em = (stepEl.querySelector('[data-f="email"]') || {}), _nm = (stepEl.querySelector('[data-f="name"]') || {});
          var _emOk = /.+@.+\..+/.test(_em.value || ''), _nmOk = ((_nm.value || '').trim().length > 0);
          var _pm = _emOk && window.truceWorkEmailError ? window.truceWorkEmailError(_em.value) : '';
          if (_pm && showEmailErr(_pm, 'site')) {
            pqTrack('pq_submit_error', { field: 'email', reason: 'personal', via: 'site' });
            try { _em.focus(); } catch (e) {}
            return;
          }
          if (!_emOk || !_nmOk) {
            var _er = stepEl.querySelector('[data-pq-err]');
            if (_er) { _er.textContent = !_emOk ? 'Add your work email so we know where to send the quote.' : 'Add your first name.'; _er.hidden = false; }
            pqTrack('pq_submit_error', { field: !_emOk && !_nmOk ? 'email+name' : (!_emOk ? 'email' : 'name'), reason: !_emOk && (_em.value || '').trim() ? 'invalid' : 'missing', via: 'site' });
            try { (!_emOk ? _em : _nm).focus(); } catch (e) {}
            return;
          }
          var _gtOk = typeof window.gtag === 'function' && !!window.google_tag_manager;
          var _leadNow = !window.__truceQuizLeadSent;
          var _need = isModal && typeof window.__trucePqBeforeSubmit === 'function' ? 2 : 1, _fired = false;
          var _part = function () {
            if (_fired) return;
            if (--_need > 0) return;
            _fired = true;
            try { submit(); } catch (err) { unbusy(); }
          };
          var _leadDone = (function () { var d = false; return function () { if (d) return; d = true; setTimeout(_part, 0); }; })();
          if (!window.__truceQuizLeadSent) {
          window.__truceQuizLeadSent = 1;
          var _p = { answer: answers.next_step || 'Get my exact pricing' };
          pqTrack('pq_step_complete', _p);
          pqTrack('pq_step_next_step_done', _p);
          pqTrack('pq_email_captured', answers.offer ? { offer: 'eoy2026' } : {});
          try {
            if (typeof fbq === 'function' && !window.__truceLeadFired) {
              window.__truceLeadFired = 1;
              fbq('track', 'Lead');
            }
          } catch (e) {}
          if (answers.fleet_size !== '1 – 9' && window.truceLiConv) window.truceLiConv(31418138);
          pqTrack('pq_step_contact_done');
          pqTrack('generate_lead', { method: 'pricing_quiz', offer: answers.offer ? 'eoy2026' : 'none' }, _gtOk ? { event_callback: _leadDone, event_timeout: 800 } : null);
          if (window.truceAdsLead) window.truceAdsLead(_em.value);
          }
          var pl = payload();
          stashSet({ email: pl.email, first_name: pl.first_name, fleet_size: pl.fleet_size, variant: window.__truceVariant || '', offer: answers.offer || '' });
          busy = true; window.__trucePqPosting = 1; busyBtn = e.target; busyLbl = busyBtn.textContent;
          busyBtn.setAttribute('aria-disabled', 'true'); busyBtn.setAttribute('aria-busy', 'true'); busyBtn.textContent = 'Sending\u2026';
          busyTimer = setTimeout(unbusy, 30000);
          setTimeout(_leadDone, _leadNow && _gtOk ? 800 : 300);
          if (_need === 2) { try { window.__trucePqBeforeSubmit(_part); } catch (err) { _part(); } }
          return;
        }
        if (nav === '1') {
          var _sk = (STEPS[i] && STEPS[i].key) || 'step', _px = {};
          if (STEPS[i].type === 'single') _px.answer = answers[_sk] || '';
          if (STEPS[i].type === 'multi') _px.answer = (answers[_sk] || []).join(' | ').slice(0, 95);
          pqTrack('pq_step_complete', _px);
          if (STEPS[i].type === 'single' || STEPS[i].type === 'multi') pqTrack('pq_step_' + _sk + '_done', _px);
          if (_sk === 'fleet_size' && (answers.fleet_size || '') && answers.fleet_size !== '1 – 9') pqTrack('pq_fleet_10plus', _px);
        }
        i = Math.min(STEPS.length - 1, Math.max(0, i + (+nav)));
        render();
      }
    });
    stepEl.addEventListener('input', validate);
    function emailFocus(ev) {
      var t = ev.target;
      if (emailFocusSent || autoFocusing || !t || !t.getAttribute || t.getAttribute('data-f') !== 'email') return;
      emailFocusSent = true;
      pqTrack('pq_email_focus', { via: ev.type === 'input' ? 'typing' : 'focus' });
    }
    stepEl.addEventListener('focusin', emailFocus);
    stepEl.addEventListener('input', emailFocus);
    if (!PQ_FINE) stepEl.addEventListener('focusin', function (ev) {
      var t = ev.target;
      if (!t || t.tagName !== 'INPUT') return;
      var h0 = window.innerHeight, live = true;
      function off() { live = false; window.removeEventListener('resize', onR); }
      function onR() {
        if (!live || window.innerHeight > h0 - 100) return;
        off();
        setTimeout(function () { try { if (document.activeElement === t) t.scrollIntoView({ block: 'center' }); } catch (x) {} }, 60);
      }
      window.addEventListener('resize', onR);
      setTimeout(off, 1500);
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) unbusy(); });
    stepEl.addEventListener('keydown', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-pq-contract]')) return;
      if (e.key === 'Enter') {
        var n = stepEl.querySelector('[data-nav="1"]') || stepEl.querySelector('[data-text]');
        if (n && !n.disabled) { e.preventDefault(); n.click(); }
      }
    });

    if (!isModal && !isInline) {
      var params = new URLSearchParams(location.search);
      var isErr = params.get('error') === '1' || params.get('errors') === 'true';
      if (params.get('submitted') === '1') i = STEPS.length - 1;
      if (isErr) {
        answers.email = params.get('email') || '';
        answers.name = ((params.get('first_name') || '') + ' ' + (params.get('last_name') || '')).trim();
        answers.company = params.get('company') || '';
        answers.phone = params.get('phone') || '';
        answers.fleet_size = params.get('fleet_size') || '';
        answers.industry = params.get('industry') || '';
        var ints = (params.get('interests') || '').split(OFFER_TAG + ' | ').join('').split(OFFER_TAG).join('');
        if (ints) answers.interests = ints.split(', ');
        i = STEPS.length - 2;
      }
      if (params.get('submitted') === '1' || isErr) {
        try { history.replaceState(null, '', location.pathname); } catch (e) {}
      }
      render();
      if (params.get('submitted') !== '1') { }
      if (isErr) pqTrack('pq_submit_error', { field: answers.email ? 'email' : 'unknown', reason: 'handler', via: 'pardot' });
      if (isErr && !(answers.email && showEmailErr(window.truceWorkEmailError.msg, 'pardot'))) {
        var msg = document.createElement('p');
        msg.className = 'pq__error';
        msg.textContent = 'Something went wrong sending your info. Please check your details and try again.';
        stepEl.insertBefore(msg, stepEl.firstChild);
      }
    } else {
      render();
    }
  }

  var instances = document.querySelectorAll('[data-pq]');
  for (var k = 0; k < instances.length; k++) pqInit(instances[k]);

  var overlay = document.querySelector('[data-pq-overlay]');
  if (overlay && location.pathname.indexOf('/pages/get-pricing') === -1) {
    var lastFocus = null, pqPushed = false, popWait = null;
    function isOpen() { return !overlay.hasAttribute('hidden'); }
    function popEntry(cb) {
      var ours = pqPushed && !!(history.state && history.state.truce_pq);
      pqPushed = false;
      if (!ours) { if (cb) cb(); return; }
      var done = false;
      popWait = function () { if (done) return; done = true; popWait = null; if (cb) cb(); };
      setTimeout(function () { if (popWait) popWait(); }, 600);
      try { history.back(); } catch (e) { popWait(); }
    }
    window.__trucePqBeforeSubmit = function (cb) { popEntry(cb); };
    function openModal() {
      var mv = window.__truceVariant ? { lp_variant: window.__truceVariant } : {};
      if (window.truceTrack) window.truceTrack('pq_view', Object.assign({ is_modal: 'yes', page: location.pathname }, mv));
      if (window.truceTrack) window.truceTrack('pq_open', Object.assign({ page: location.pathname, cta: 'modal' }, mv));
      lastFocus = document.activeElement;
      overlay.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('pq-modal-open');
      overlay.setAttribute('tabindex', '-1'); overlay.focus();
      if (!pqPushed && !popWait) { try { history.pushState({ truce_pq: 1 }, '', location.href); pqPushed = true; } catch (e) {} }
    }
    function hideModal() {
      if (window.truceTrack) window.truceTrack('pq_close', Object.assign({ page: location.pathname }, window.__truceVariant ? { lp_variant: window.__truceVariant } : {}));
      overlay.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('pq-modal-open');
      if (lastFocus) lastFocus.focus();
    }
    function closeModal() { hideModal(); popEntry(null); }
    window.addEventListener('popstate', function (e) {
      if (popWait) { e.stopImmediatePropagation(); popWait(); return; }
      if (pqPushed && isOpen()) { e.stopImmediatePropagation(); pqPushed = false; hideModal(); return; }
      if (e.state && e.state.truce_pq) e.stopImmediatePropagation();
    }, true);
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted || !isOpen()) return;
      if (history.state && history.state.truce_pq) { pqPushed = true; return; }
      try { history.pushState({ truce_pq: 1 }, '', location.href); pqPushed = true; } catch (e) {}
    });
    var pressTarget = null;
    document.addEventListener('mousedown', function (e) { pressTarget = e.target; });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/pages/get-pricing"]');
      if (a) { e.preventDefault(); openModal(); return; }
      if (e.target.closest && e.target.closest('[data-pq-close]')) { closeModal(); return; }
      if (e.target === overlay && pressTarget === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeModal();
    });
  } else if (overlay) {
    overlay.remove();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var open = null;
  function closeVlb() {
    if (!open) return;
    open.remove(); open = null;
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-video-lightbox]');
    if (btn) {
      var url = btn.getAttribute('data-video-lightbox');
      var ov = document.createElement('div');
      ov.className = 'vlb-overlay';
      ov.innerHTML = '<div class="vlb-dialog" role="dialog" aria-modal="true" aria-label="Video">' +
        '<button type="button" class="vlb-close" data-vlb-close aria-label="Close">&times;</button>' +
        '<div class="vlb-frame"><iframe src="' + url + '" allow="autoplay; fullscreen; encrypted-media" allowfullscreen loading="eager" frameborder="0"></iframe></div></div>';
      document.body.appendChild(ov);
      document.documentElement.style.overflow = 'hidden';
      open = ov;
      ov.querySelector('.vlb-close').focus();
      return;
    }
    if (open && (e.target === open || (e.target.closest && e.target.closest('[data-vlb-close]')))) closeVlb();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVlb(); });
});

window.truceWorkEmailError = (function () {
  var BLOCK = false;
  var MSG = 'Please enter your company email address. Personal email addresses are not accepted.';
  var MSG_CHECK = 'Please check your email address and try again.';
  var D = ['gmail.com', 'googlemail.com', 'yahoo.com', 'ymail.com', 'rocketmail.com', 'yahoo.co.uk', 'yahoo.ca', 'yahoo.co.in', 'yahoo.com.mx',
    'hotmail.com', 'hotmail.co.uk', 'outlook.com', 'live.com', 'msn.com', 'windowslive.com', 'aol.com', 'aim.com', 'icloud.com', 'me.com', 'mac.com',
    'protonmail.com', 'protonmail.ch', 'proton.me', 'pm.me', 'gmx.com', 'gmx.net', 'gmx.us', 'mail.com', 'email.com', 'usa.com', 'yandex.com', 'yandex.ru', 'mail.ru',
    'zoho.com', 'zohomail.com', 'fastmail.com', 'fastmail.fm', 'hushmail.com', 'tutanota.com', 'tuta.io', 'inbox.com', 'lycos.com', 'excite.com',
    'qq.com', '163.com', '126.com', 'sina.com', 'rediffmail.com',
    'att.net', 'sbcglobal.net', 'bellsouth.net', 'pacbell.net', 'swbell.net', 'ameritech.net', 'flash.net', 'prodigy.net', 'snet.net', 'nvbell.net',
    'comcast.net', 'verizon.net', 'cox.net', 'charter.net', 'spectrum.net', 'earthlink.net', 'mindspring.com', 'juno.com', 'netzero.net', 'netzero.com', 'peoplepc.com',
    'optonline.net', 'optimum.net', 'frontier.com', 'frontiernet.net', 'centurylink.net', 'centurytel.net', 'embarqmail.com', 'windstream.net', 'q.com', 'qwest.net',
    'roadrunner.com', 'rr.com', 'twc.com', 'brighthouse.com', 'mchsi.com', 'suddenlink.net', 'cableone.net', 'sparklight.net', 'bresnan.net', 'wowway.com',
    'rcn.com', 'ptd.net', 'knology.net', 'tds.net', 'hughes.net'];
  function check(email) {
    if (!BLOCK) return '';
    var m = /@([^@\s]+)$/.exec(String(email || '').trim().toLowerCase());
    if (!m) return '';
    var d = m[1].replace(/\.+$/, '');
    for (var k = 0; k < D.length; k++) {
      if (d === D[k] || d.slice(-(D[k].length + 1)) === '.' + D[k]) return MSG;
    }
    return '';
  }
  check.msg = BLOCK ? MSG : MSG_CHECK;
  return check;
})();

window.truceUtm = (function () {
  var KEYS =['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var DAY = 864e5, now = Date.now(), cur = {}, any = false, stored = null, p = null, lp = null, clk = null;
  try { p = new URLSearchParams(location.search); } catch (e) {}
  function q(k) { try { return p ? (p.get(k) || '').trim() : ''; } catch (e) { return ''; } }
  function ck(n) { try { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } }
  function get(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function put(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  KEYS.forEach(function (k) { var v = q(k); if (v) { cur[k] = v.slice(0, 200); any = true; } });
  stored = get('truce_utm');
  if (!stored || !stored.v || !stored.ts || (now - stored.ts) > 30 * DAY) stored = null;
  if (any && !stored) {
    stored = { v: cur, ts: now, page: location.pathname };
    put('truce_utm', stored);
  }
  lp = get('truce_lp');
  if (!lp || !lp.v || !lp.ts || (now - lp.ts) > 90 * DAY) {
    lp = { v: location.pathname.slice(0, 255), ts: now };
    put('truce_lp', lp);
  }
  clk = get('truce_click');
  if (!clk || typeof clk !== 'object') clk = {};
  Object.keys(clk).forEach(function (k) { if (!clk[k] || !clk[k].v || !clk[k].ts || (now - clk[k].ts) > 90 * DAY) delete clk[k]; });
  function setc(k, v) { if (v) clk[k] = { v: String(v).slice(0, 255), ts: now }; }
  setc('gclid', q('gclid'));
  var fb = q('fbclid'), fbc = ck('_fbc');
  if (fb) setc('fbc', fbc && fbc.slice(-fb.length) === fb ? fbc : 'fb.1.' + now + '.' + fb);
  else if (fbc && !clk.fbc) setc('fbc', fbc);
  setc('li', q('li_fat_id') || (clk.li ? '' : ck('li_fat_id')));
  put('truce_click', clk);
  return function () {
    var src = (stored && stored.v) || cur, out = {};
    KEYS.forEach(function (k) { if (src[k]) out[k] = String(src[k]).slice(0, 200); });
    if (clk.gclid) out.gclid = clk.gclid.v;
    if (clk.fbc) out.meta_click_id = clk.fbc.v;
    if (clk.li) out.linkedin_click_id = clk.li.v;
    if (lp && lp.v) out.landing_page = lp.v;
    return out;
  };
})();

(function () {
  var PF = { gclid: 'Gclid', meta_click_id: 'Meta_Click_ID', linkedin_click_id: 'LinkedIn_Click_ID', landing_page: 'Landing_Page' };
  function deco(s) {
    var u; try { u = window.truceUtm ? window.truceUtm() : {}; } catch (e) { u = {}; }
    var keys = Object.keys(u); if (!s || !keys.length) return s;
    try {
      var url = new URL(s, location.href), ch = false;
      keys.forEach(function (k) { var n = PF[k] || k; if (!url.searchParams.has(n)) { url.searchParams.set(n, u[k]); ch = true; } });
      return ch ? url.toString() : s;
    } catch (e) { return s; }
  }
  function apply() {
    var frames = document.querySelectorAll('iframe[src*="go.trucesoftware.com/l/"], iframe[data-src*="go.trucesoftware.com/l/"]');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i], ds = f.getAttribute('data-src'), s = f.getAttribute('src'), d;
      if (ds && ds.indexOf('go.trucesoftware.com/l/') !== -1 && (d = deco(ds)) !== ds) f.setAttribute('data-src', d);
      if (s && s.indexOf('go.trucesoftware.com/l/') !== -1 && (d = deco(s)) !== s) f.setAttribute('src', d);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();

(function () {
  var vids = document.querySelectorAll('video[data-play-on-view]');
  if (!vids.length) return;
  function start(v) {
    var ps = v.getAttribute('data-poster');
    if (ps && !v.getAttribute('poster')) v.setAttribute('poster', ps);
    try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
  }
  if (!('IntersectionObserver' in window)) { for (var k = 0; k < vids.length; k++) start(vids[k]); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (en.isIntersecting) start(en.target);
      else if (!en.target.paused) en.target.pause();
    });
  }, { rootMargin: '300px 0px' });
  for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
})();

window.truceOaiConsent = function () {
  try {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (typeof window.oaiq !== 'function' || !cp || typeof cp.marketingAllowed !== 'function') return;
    var ok = cp.marketingAllowed() && (typeof cp.saleOfDataAllowed !== 'function' || cp.saleOfDataAllowed());
    window.oaiq('consent', !!ok);
  } catch (e) {}
};
document.addEventListener('visitorConsentCollected', window.truceOaiConsent);
window.addEventListener('load', window.truceOaiConsent);
window.truceOaiLead = function () {
  try {
    if (typeof window.oaiq !== 'function' || window.__truceOaiLeadSent) return;
    window.__truceOaiLeadSent = 1;
    window.truceOaiConsent();
    var id = 'lead-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: id });
  } catch (e) {}
};
window.truceAdsLead = function (email) {
  try {
    if (window.truceOaiLead) window.truceOaiLead();
    var to = window.TRUCE_GADS_LEAD;
    if (!to || typeof gtag !== 'function' || window.__truceAdsLeadSent) return;
    window.__truceAdsLeadSent = 1;
    var em = String(email || '').trim().toLowerCase();
    if (em) gtag('set', 'user_data', { email: em });
    gtag('event', 'conversion', { send_to: to });
  } catch (e) {}
};
window.truceLiConv = function (id) {
  try {
    if (!id || typeof window.lintrk !== 'function') return;
    window.__truceLiSent = window.__truceLiSent || {};
    if (window.__truceLiSent[id]) return;
    window.__truceLiSent[id] = 1;
    window.lintrk('track', { conversion_id: id });
  } catch (e) {}
};
var TRUCE_LI_CONV = { generate_lead: 31418130, pardot_form_submit: 31418130, pq_open: 31418146 };
window.truceTrack = function (name, params, gx) {
  try { var na = window.__truceNav || localStorage.getItem('truce_nav'); if (na && !(params && 'nav_arm' in params)) params = Object.assign({}, params || {}, { nav_arm: na }); } catch (e) {}
  try { if (typeof gtag === 'function') gtag('event', name, gx ? Object.assign({}, params || {}, gx) : (params || {})); } catch (e) {}
  try { if (typeof fbq === 'function') fbq('trackCustom', name, params || {}); } catch (e) {}
  if (TRUCE_LI_CONV[name]) window.truceLiConv(TRUCE_LI_CONV[name]);
};
document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var track = window.truceTrack;
  window.addEventListener('message', function (event) {
    if (event.data !== 'pardotFormSubmitted') return;
    var origin = String(event.origin || '');
    if (origin.indexOf('trucesoftware.com') === -1 && origin.indexOf('pardot.com') === -1) return;
    track('pardot_form_submit', { page: location.pathname });
  });

  (function () {
    var CSS =
      '.activator{--shopify-agent-bg-color:#FF671F !important;' +
      '--shopify-agent-text-color:#FFFFFF !important;opacity:1 !important;' +
      'transition:background-color .3s ease;}' +
      '.activator:hover,.activator:focus-visible{--shopify-agent-bg-color:#FF8547 !important;}';
    function paint(root) {
      if (!root || (root.getElementById && root.getElementById('truce-chat-launcher'))) return;
      try {
        var st = document.createElement('style');
        st.id = 'truce-chat-launcher';
        st.textContent = CSS;
        root.appendChild(st);
      } catch (e) {}
    }
    function paintRuntime(host) {
      var r = host.shadowRoot && host.shadowRoot.querySelector('shopify-agent-runtime');
      if (r && r.shadowRoot) { paint(r.shadowRoot); return true; }
      return false;
    }
    var tries = 0;
    (function arm() {
      var host = document.querySelector('shopify-chat');
      if (host && host.shadowRoot) {
        paint(host.shadowRoot);
        paintRuntime(host);
        try {
          if (!host.__truceLauncherObs) {
            host.__truceLauncherObs = new MutationObserver(function () {
              var n = 0;
              (function tryRt() { if (paintRuntime(host)) return; if (++n < 20) setTimeout(tryRt, 250); })();
            });
            host.__truceLauncherObs.observe(host.shadowRoot, { childList: true, subtree: true });
          }
        } catch (e) {}
      } else if (++tries < 40) {
        setTimeout(arm, 500);
      }
    })();
  })();

  (function () {
    var fired = false;
    document.addEventListener('click', function (e) {
      if (fired) return;
      var path = (e.composedPath && e.composedPath()) || [];
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (n && n.tagName === 'SHOPIFY-CHAT') {
          fired = true;
          track('chat_open', { page: location.pathname });
          return;
        }
      }
    }, true);
  })();

  (function () {
    if (document.getElementById('lpf')) return;
    if (location.pathname.indexOf('/pages/fleet') === 0) return;
    var fired = {}, t0 = Date.now();
    function check() {
      var H = document.body.scrollHeight;
      if (H <= window.innerHeight * 1.25) return;
      var d = (window.scrollY + window.innerHeight) / H;
      [[0.10, 'scroll_10'], [0.25, 'scroll_25'], [0.5, 'scroll_50'], [0.75, 'scroll_75']].forEach(function (r) {
        if (d >= r[0] && !fired[r[1]]) { fired[r[1]] = 1; track(r[1], { page: location.pathname }); }
      });
      if (!fired.quality_visit && fired.scroll_75 && (Date.now() - t0) > 30000) {
        fired.quality_visit = 1;
        track('quality_visit', { page: location.pathname, qv_reason: 'scroll75_30s' });
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    setInterval(check, 5000);
    check();
  })();

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('tel:') === 0) track('phone_click', { link_text: (a.textContent || '').trim().slice(0, 40) });
    else if (href.indexOf('mailto:') === 0) track('email_click', { link_text: (a.textContent || '').trim().slice(0, 40) });
    else if (href.indexOf('#get-started') > -1) track('cta_click', { cta: 'get_started_anchor', page: location.pathname });
    else if (href.indexOf('/pages/contact-truce') > -1) track('cta_click', { cta: 'contact', page: location.pathname });
    else if (/talk-with-a-truce-solution-expert/.test(href)) track('cta_click', { cta: 'talk_to_expert', page: location.pathname });
  });
  document.querySelectorAll('video').forEach(function (v) {
    var sent = false;
    v.addEventListener('play', function () {
      if (sent) return; sent = true;
      var src = (v.currentSrc || '').split('/').pop().split('?')[0];
      track('video_play', { video: src.slice(0, 60), page: location.pathname });
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var q = e.target.closest && e.target.closest('.truce-accordion__q, .faq-item summary, [data-faq-q]');
    if (!q) return;
    track('faq_open', { question: (q.textContent || '').trim().slice(0, 60), page: location.pathname });
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.module-value__tab');
    if (!t) return;
    track('value_tab_click', { tab: (t.textContent || '').trim().slice(0, 40), page: location.pathname });
  });
  document.addEventListener('click', function (e) {
    var f = e.target.closest && e.target.closest('.insights-filter');
    if (!f) return;
    track('blog_filter_click', { category: (f.textContent || '').trim().slice(0, 40) });
  });
});

(function () {
  var bar = document.querySelector('.insights-filters');
  if (!bar || !window.fetch || !window.DOMParser || !history.pushState) return;
  var box = bar.parentNode, sec = bar.closest('.insights-index'), seq = 0;
  function clean(u) { return new URL(u, location.href).pathname.replace(/\/$/, ''); }
  function fadeIn(root) {
    root.querySelectorAll('img.lazy-fade').forEach(function (img) {
      function on() { img.classList.add('is-loaded'); }
      if (img.complete && img.naturalWidth) on(); else { img.addEventListener('load', on); img.addEventListener('error', on); }
    });
  }
  function setActive(u) {
    var p = clean(u);
    bar.querySelectorAll('a.insights-filter').forEach(function (a) {
      var on = clean(a.href) === p;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
  }
  function toCard(feat, tpl) {
    var t = feat && feat.querySelector('h2 a');
    if (!t || !tpl) return null;
    var c = tpl.cloneNode(true), href = t.getAttribute('href');
    var ca = c.querySelector('.insights-card__img'), fi = feat.querySelector('.insights-featured__media img');
    if (ca && fi) {
      var ci = ca.querySelector('img');
      ca.setAttribute('href', href);
      ci.setAttribute('src', fi.getAttribute('src').replace(/([?&]width=)\d+/, '$1720'));
      ci.setAttribute('alt', fi.getAttribute('alt') || '');
      ci.setAttribute('loading', 'lazy');
      ci.classList.remove('is-loaded');
    } else if (ca) ca.remove();
    var cp = c.querySelector('.insights-pill'), fp = feat.querySelector('.insights-pill');
    if (cp && fp) cp.textContent = fp.textContent; else if (cp) cp.remove();
    var ct = c.querySelector('.insights-card__title a');
    if (ct) { ct.setAttribute('href', href); ct.textContent = t.textContent; }
    var cb = c.querySelector('.insights-byline'), fb = feat.querySelector('.insights-byline');
    if (cb && fb) cb.innerHTML = fb.innerHTML; else if (cb) cb.remove();
    var cbi = c.querySelector('.insights-byline__photo');
    if (cbi) cbi.remove();
    return c;
  }
  function swap(doc) {
    var nGrid = doc.querySelector('.insights-index .insights-grid'), oGrid = box.querySelector('.insights-grid');
    if (!nGrid || !oGrid) return false;
    var before = bar.getBoundingClientRect().top;
    var keep = box.querySelector('.insights-featured h2 a'), keepUrl = keep ? clean(keep.getAttribute('href')) : '';
    var nFeat = doc.querySelector('.insights-index .insights-featured');
    var nLink = nFeat && nFeat.querySelector('h2 a');
    if (nLink && clean(nLink.getAttribute('href')) !== keepUrl) {
      var c = toCard(nFeat, nGrid.querySelector('.insights-card') || oGrid.querySelector('.insights-card'));
      if (c) nGrid.insertBefore(c, nGrid.firstChild);
    }
    var cards = nGrid.querySelectorAll('.insights-card');
    if (keepUrl && cards.length > 1) cards.forEach(function (k) {
      var l = k.querySelector('.insights-card__title a');
      if (l && clean(l.getAttribute('href')) === keepUrl) k.remove();
    });
    var nPag = doc.querySelector('.insights-index .insights-pagination'), oPag = box.querySelector('.insights-pagination');
    oGrid.replaceWith(nGrid);
    if (oPag) oPag.remove();
    if (nPag) nGrid.after(nPag);
    fadeIn(box);
    var d = bar.getBoundingClientRect().top - before;
    if (d) window.scrollBy(0, d);
    return true;
  }
  function load(u, push) {
    var my = ++seq;
    setActive(u);
    if (sec) sec.classList.add('is-loading');
    var g = box.querySelector('.insights-grid'); if (g) g.setAttribute('aria-busy', 'true');
    fetch(u, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      if (my !== seq) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (!swap(doc)) throw new Error('grid');
      if (sec) sec.classList.remove('is-loading');
      if (doc.title) document.title = doc.title;
      if (push) history.pushState({ insights: 1 }, '', u);
    }).catch(function () {
      if (my === seq) location.href = u;
    });
  }
  try { history.replaceState(Object.assign({}, history.state, { insights: 1 }), '', location.href); } catch (e) {}
  setActive(location.href);
  bar.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.insights-filter');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.origin !== location.origin) return;
    e.preventDefault();
    if (clean(a.href) === clean(location.href)) return;
    load(a.href, true);
  });
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.insights) load(location.href, false);
  });
})();

(function () {
  var forms = document.querySelectorAll('[data-nl-form]');
  for (var i = 0; i < forms.length; i++) (function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var hp = f.querySelector('[name="nl_website"]');
      if (hp && hp.value) return;
      var H = (f.getAttribute('data-nl-handler') || '').trim();
      var email = ((f.querySelector('input[type="email"]') || {}).value || '').trim();
      if (!H || !email) return;
      var src = f.getAttribute('data-nl-source') || 'newsletter';
      var body = new URLSearchParams();
      body.append('email', email);
      body.append('signup_source', src);
      body.append('blog_post', f.getAttribute('data-nl-post') || location.pathname);
      try { var u = window.truceUtm ? window.truceUtm() : {}; Object.keys(u).forEach(function (k) { body.append(k, u[k]); }); } catch (err) {}
      try {
        fetch(H, { method: 'POST', mode: 'no-cors', body: body,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
      } catch (err) {}
      if (window.truceTrack) window.truceTrack('nl_submit', { form: src, page: location.pathname });
      var done = document.createElement('p');
      done.className = 'nl-done';
      done.setAttribute('role', 'status');
      done.textContent = 'You\u2019re in. Watch your inbox for the next one.';
      f.parentNode.replaceChild(done, f);
    });
  })(forms[i]);
})();

(function () {
  var bodies = document.querySelectorAll('[data-bpost-content]');
  for (var i = 0; i < bodies.length; i++) {
    var tables = bodies[i].querySelectorAll('table');
    for (var j = 0; j < tables.length; j++) {
      var t = tables[j];
      if (!t.classList.contains('truce-table')) t.classList.add('truce-table');
      if (!(t.parentElement && t.parentElement.classList.contains('truce-table-wrap'))) {
        var w = document.createElement('div');
        w.className = 'truce-table-wrap';
        t.parentNode.insertBefore(w, t);
        w.appendChild(t);
      }
    }
  }
})();



window.truceVideo = function (el, opts) {
  if (!el || el.__truceWired) return; el.__truceWired = 1;
  opts = opts || {};
  var label = opts.label || 'video', fired = {};
  var isW = (el.tagName || '').toLowerCase() === 'wistia-player';

  function ev(name, extra) {
    var pr = { video: label, player: isW ? 'wistia' : 'html5', page: location.pathname };
    if (window.__truceVariant) pr.lp_variant = window.__truceVariant;
    for (var k in (extra || {})) pr[k] = extra[k];
    if (window.truceTrack) window.truceTrack(name, pr);
  }
  function pct() {
    if (isW) return typeof el.percentWatched === 'number' ? el.percentWatched : 0;
    return (el.duration && isFinite(el.duration)) ? (el.currentTime / el.duration) : 0;
  }
  var everSeen = false;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) everSeen = true; });
    }, { threshold: 0.5 }).observe(el);
  } else { everSeen = true; }

  function mark() {
    var q = pct();
    [[0.25, 'video_25'], [0.5, 'video_50'], [0.75, 'video_75']].forEach(function (t) {
      if (q >= t[0] && !fired[t[1]]) {
        fired[t[1]] = 1; ev(t[1], { on_screen: everSeen ? 'yes' : 'no' });
        if (t[1] === 'video_50' && everSeen) window.__truceV50 = 1;
      }
    });
  }
  el.addEventListener('play', function () {
    if (el.__truceSuppressPlay) return;
    if (!fired.play) { fired.play = 1; ev('video_play'); }
  });
  el.addEventListener(isW ? 'percent-watched-change' : 'timeupdate', mark);
  if (isW) el.addEventListener('time-update', mark);

  function play() { try { var r = el.play && el.play(); if (r && r.catch) r.catch(function () {}); } catch (e) {} }

  var unmuted = false, btn = null;
  function sawUnmute() { if (el.__truceSuppressUnmute) return;
    if (!unmuted) { unmuted = true; ev('video_unmute'); } }
  function paintBtn() {
    if (!btn) return;
    btn.textContent = el.muted ? '\uD83D\uDD0A  Click to play sound' : '\uD83D\uDD07  Click to turn off sound';
  }
  if (isW) {
    el.addEventListener('mute-change', function (e) {
      var m = (e && e.detail && typeof e.detail.isMuted !== 'undefined') ? e.detail.isMuted : el.muted;
      if (!m) sawUnmute();
      paintBtn();
    });
    el.addEventListener('volume-change', function (e) {
      var d = (e && e.detail) || {};
      if (d.isMuted === false || (typeof d.volume === 'number' && d.volume > 0 && !el.muted)) sawUnmute();
      paintBtn();
    });
    el.addEventListener('silent-playback-mode-change', function (e) {
      var d = (e && e.detail) || {};
      if (d.isInSilentPlaybackMode === false) sawUnmute();
      paintBtn();
    });
  }
  if (!isW && opts.unmute !== false) {
    var host = el.parentNode;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'truce-sound-btn';
    btn.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:9px;width:100%;' +
      'margin:10px 0 0;padding:13px 16px;border:0;border-radius:10px;cursor:pointer;' +
      'appearance:none;-webkit-appearance:none;background:#052756;color:#fff;' +
      'box-shadow:inset 0 0 0 2px #FF671F;' +
      'font:800 15px/1.2 system-ui,-apple-system,"Segoe UI",sans-serif;letter-spacing:.2px';
    paintBtn();
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (el.muted) {
        el.removeAttribute('muted');
        el.removeAttribute('silent-autoplay');
        el.muted = false;
        try { el.volume = 1; } catch (x) {}
        sawUnmute();
      } else {
        el.muted = true;
      }
      paintBtn();
    });
    host.appendChild(btn);
  }

  if (!isW && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { if (el.paused && el.__truceWanted !== 0) play(); }
        else if (!el.paused) { try { el.pause(); } catch (x) {} }
      });
    }, { threshold: 0.25 }).observe(el);
  }
};

(function () {
  function scan() {
    var zones = document.querySelectorAll('[data-truce-ctp]');
    for (var z = 0; z < zones.length; z++) {
      var p = zones[z].querySelector('wistia-player, video');
      if (!p || p.__truceZoned) continue;
      if ((p.tagName || '').toLowerCase() === 'wistia-player') p = window.truceRecreatePlayer(p);
      p.__truceZoned = 1;
      var label = zones[z].getAttribute('data-truce-ctp') || 'video';
      var pst = zones[z].getAttribute('data-truce-poster');
      p.setAttribute('data-truce-video', label);
      p.setAttribute('data-truce-unmute', 'no');
      p.setAttribute('data-truce-clicktoplay', 'yes');
      if (pst) p.setAttribute('data-truce-poster', pst);
    }
    var list = document.querySelectorAll('[data-truce-video]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-truce-clicktoplay') === 'yes') window.truceClickToPlay(list[i]);
      window.truceVideo(list[i], {
        label: list[i].getAttribute('data-truce-video') || 'video',
        unmute: list[i].getAttribute('data-truce-unmute') !== 'no'
      });
    }
  }
  function ready() { setTimeout(scan, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();

window.truceRecreatePlayer = function (old) {
  try {
    if (!old || (old.tagName || '').toLowerCase() !== 'wistia-player') return old;
    var parent = old.parentNode;
    if (!parent || !old.getAttribute('media-id')) return old;
    var fresh = document.createElement('wistia-player');
    ['media-id', 'seo', 'aspect', 'data-truce-video', 'data-truce-unmute',
     'data-truce-clicktoplay', 'data-truce-poster'].forEach(function (a) {
      if (old.hasAttribute(a)) fresh.setAttribute(a, old.getAttribute(a));
    });
    try { old.pause && old.pause(); } catch (e) {}
    parent.replaceChild(fresh, old);
    return fresh;
  } catch (e) { return old; }
};

window.truceClickToPlay = function (v) {
  if (!v || v.__truceHeld) return; v.__truceHeld = 1;
  var isW = (v.tagName || '').toLowerCase() === 'wistia-player';
  var userStarted = false;
  v.__truceSuppressPlay = true;
  v.__truceWanted = 0;
  v.removeAttribute('autoplay'); v.removeAttribute('silent-autoplay');
  try { v.autoplay = false; } catch (e) {}
  ['pointerdown', 'click', 'keydown', 'touchstart'].forEach(function (t) {
    v.addEventListener(t, function () { userStarted = true; v.__truceSuppressPlay = false; }, true);
  });
  function hold() {
    if (userStarted) return;
    try { v.pause && v.pause(); } catch (e) {}
    try { if (v.currentTime > 0.05) v.currentTime = 0; } catch (e) {}
  }
  v.addEventListener('api-ready', hold);
  v.addEventListener('play', function () { if (!userStarted) hold(); });
  [0, 300, 900, 2000, 4000].forEach(function (ms) { setTimeout(hold, ms); });

  if (!isW) { v.setAttribute('controls', ''); return; }
  var wrap = v.parentNode;
  if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
  var ovl = document.createElement('button');
  ovl.type = 'button';
  ovl.className = 'truce-play-ovl';
  ovl.setAttribute('aria-label', 'Play video');
  var poster = v.getAttribute('data-truce-poster') || '';
  var pw = wrap.offsetWidth || 560;
  var bs = poster ? Math.round(Math.min(76, Math.max(48, pw * 0.14))) : 76;
  ovl.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:6;border:0;margin:0;' +
    'padding:0;cursor:pointer;appearance:none;-webkit-appearance:none;' +
    (poster ? 'background:#031A3B url(' + poster + ') center/cover no-repeat;' : 'background:rgba(5,39,86,.28);') +
    'display:flex;flex-direction:column;align-items:center;gap:' + (bs < 60 ? 8 : 12) + 'px;' +
    (poster ? 'justify-content:flex-end;padding-bottom:6%' : 'justify-content:center');
  ovl.innerHTML = '<span style="display:flex;align-items:center;justify-content:center;width:' + bs + 'px;' +
    'height:' + bs + 'px;border-radius:50%;background:#FF671F;box-shadow:0 10px 30px rgba(0,0,0,.45)">' +
    '<svg width="' + Math.round(bs * 0.4) + '" height="' + Math.round(bs * 0.45) + '" viewBox="0 0 30 34" fill="none" aria-hidden="true">' +
    '<path d="M29 17 0 34V0z" fill="#fff"/></svg></span>' +
    '<span style="font:800 ' + (bs < 60 ? 13 : 15) + 'px/1.2 system-ui,-apple-system,sans-serif;color:#fff;' +
    'text-shadow:0 2px 10px rgba(0,0,0,.6)">Click to play</span>';
  ovl.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    userStarted = true;
    v.__truceSuppressPlay = false;
    v.__truceSuppressUnmute = 1;
    window.truceSetSilent(v, false);
    try { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } catch (x) {}
    window.truceSetSilent(v, false);
    setTimeout(function () { v.__truceSuppressUnmute = 0; }, 1500);
    ovl.remove();
    var mountWhenAudible = function () {
      if (window.truceIsSilent(v)) return;
      v.__truceSilent = false;
      window.truceSoundToggle(v, wrap);
    };
    [300, 900, 1800].forEach(function (ms) { setTimeout(mountWhenAudible, ms); });
    ['mute-change', 'volume-change', 'silent-playback-mode-change'].forEach(function (t) {
      v.addEventListener(t, mountWhenAudible);
    });
  });
  wrap.appendChild(ovl);
};

window.truceSetSilent = function (v, silent) {
  try { v.muted = !!silent; } catch (x) {}
  try { v.volume = silent ? 0 : 1; } catch (x) {}
  v.__truceSilent = !!silent;
};
window.truceIsSilent = function (v) {
  try { if (v.muted === true) return true; } catch (x) {}
  try { if (typeof v.volume === 'number' && v.volume === 0) return true; } catch (x) {}
  return false;
};

window.truceSoundToggle = function (v, wrap) {
  if (!v || v.__truceSnd) return; v.__truceSnd = 1;
  if (!wrap) wrap = v.parentNode;
  if (wrap && getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
  var ON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">'
    + '<path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff"/>'
    + '<path d="M16.5 8.5a5 5 0 010 7M19 6a8.5 8.5 0 010 12" stroke="#fff" stroke-width="1.8"'
    + ' stroke-linecap="round"/></svg>';
  var OFF = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">'
    + '<path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff"/>'
    + '<path d="M16.5 9.5l5 5M21.5 9.5l-5 5" stroke="#fff" stroke-width="1.8"'
    + ' stroke-linecap="round"/></svg>';
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'truce-snd';
  b.style.cssText = 'position:absolute;top:10px;right:10px;z-index:7;width:38px;height:38px;'
    + 'border:0;border-radius:50%;padding:0;cursor:pointer;display:flex;align-items:center;'
    + 'justify-content:center;background:rgba(5,39,86,.72);backdrop-filter:blur(2px);'
    + '-webkit-backdrop-filter:blur(2px);box-shadow:0 2px 10px rgba(0,0,0,.35);appearance:none;'
    + '-webkit-appearance:none;';
  function paint() {
    var m = !!v.__truceSilent;
    b.innerHTML = m ? OFF : ON;
    b.setAttribute('aria-label', m ? 'Turn sound on' : 'Mute video');
    b.title = m ? 'Turn sound on' : 'Mute video';
  }
  b.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    var wasSilent = !!v.__truceSilent;
    window.truceSetSilent(v, !wasSilent);
    setTimeout(function () {
      var actual = window.truceIsSilent(v);
      if (actual !== !!v.__truceSilent) { v.__truceSilent = actual; paint(); }
    }, 250);
    if (!wasSilent && window.truceTrack) {
      window.truceTrack('video_mute', { video: v.getAttribute('data-truce-video') || 'video',
        player: 'wistia', page: location.pathname,
        lp_variant: window.__truceVariant || undefined, source: 'toggle' });
    }
    paint();
  });
  ['mute-change', 'volume-change', 'silent-playback-mode-change'].forEach(function (t) {
    v.addEventListener(t, function () {
      var s = window.truceIsSilent(v);
      if (s !== !!v.__truceSilent) { v.__truceSilent = s; paint(); }
    });
  });
  [200, 700, 1500].forEach(function (ms) { setTimeout(paint, ms); });
  paint();
  if (wrap) wrap.appendChild(b);
};

(function () {
  if (location.pathname.replace(/\/$/, '') !== '/pages/road') return;
  var arm = 'road_autoplay';
  try { if (new URLSearchParams(location.search).get('road_lp') === 'road_clickplay') arm = 'road_clickplay'; } catch (e) {}
  window.__truceVariant = arm;
  function init() {
    if (window.truceTrack) window.truceTrack('road_variant_assigned', { lp_variant: arm, page: location.pathname });
    var v = document.querySelector('.hero__video wistia-player, .hero wistia-player, .hero__video video, .hero video, [data-hero-video]');
    if (!v) return;
    var isW = (v.tagName || '').toLowerCase() === 'wistia-player';
    v.setAttribute('data-truce-video', 'hero_road');
    if (!isW) { v.muted = true; v.setAttribute('playsinline', ''); } else { v.muted = true; }
    if (arm === 'road_autoplay') {
      v.__truceWanted = 1;
      v.setAttribute('data-truce-unmute', 'yes');
      if (!isW) {
        v.setAttribute('muted', ''); v.setAttribute('autoplay', '');
        try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () { v.setAttribute('controls', ''); }); } catch (e) {}
      }
    } else {
      v = window.truceRecreatePlayer(v);
      v.setAttribute('data-truce-video', 'hero_road');
      var zp = v.parentNode && v.parentNode.closest ? v.parentNode.closest('[data-truce-poster]') : null;
      if (zp) v.setAttribute('data-truce-poster', zp.getAttribute('data-truce-poster'));
      window.truceClickToPlay(v);
    }
    window.truceVideo(v, { label: 'hero_road', unmute: arm === 'road_autoplay' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
